import { MouseEventHandler } from "react";
import "../../../../Styles/main.scss"
import { EditProfileIcon } from "../../../Shared/Components/SvgIcons"

function UserProfileExperienceItem(props: {
    workPosition: string
    companyName: string
    startDate: any
    endDate: string
    editIcon?: boolean
    onClick?: MouseEventHandler<HTMLDivElement>
    onClickCompany?: () => void  | undefined
    onClickWebsite?: () => void  | undefined
    org_id: null | number 
    isLastItem: boolean
    is_in_edusiia?: boolean
    websiteUrl: string
}) {

    return (
        <><div className={`user-profile-experience-item ${props.isLastItem && "user-profile-experience-item--border-none"}`}>
            <div className="user-profile-experience-item__job-container">
                <div className="user-profile-experience-item__position">{props.workPosition}</div>
                <div className={`user-profile-experience-item__company ${props.is_in_edusiia && "user-profile-experience-item__company--linked"}`}> 
                    <p className={`user-profile-experience-item__company-profile ${props.websiteUrl ? "" : "user-profile-experience-item__company-profile--no-link"}`} onClick={props.is_in_edusiia && props.org_id ? props?.onClickCompany : props?.onClickWebsite}>{props.companyName}</p>
                </div>
                <div className="user-profile-experience-item__date-container">
                    <div className="user-profile-experience-item__date">{props.startDate + " - " + props.endDate} </div>
                </div>
            </div>
        </div>
        <div className="user-profile-experience-item__right-section">
                {props.editIcon && (
                    <div onClick={props.onClick} className="user-profile-experience-item__icon">
                        <EditProfileIcon modifier="small" color="#60A49F" />
                    </div>
                )}
            </div>
            </>
    )
}

export default UserProfileExperienceItem
